import cx from "classnames";
import { contentLabel } from "lib/styleguide/base.scss";
import React from "react";
import styles from "./ResultsGroup.scss";

export const ResultsGroup = ({ title, children, footer, noPadding, headingClassName }) => (
  <div className={styles.ResultsGroup}>
    <div className={cx(styles.heading, headingClassName, !noPadding && styles.leftRightPadding)}>
      <div className={cx(contentLabel, styles.sectionTitle)}>{title}</div>
    </div>
    <div className={styles.sectionContent}>{children}</div>
    <div className={styles.sectionFooter}>{footer}</div>
  </div>
);
